module.exports = __webpack_public_path__ + "static/media/temp_w_domu_ok_3.d11e7170.svg";